import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

/* ===================== ACTIONS ===================== */

// 👉 GET PARTY BY FIRM
export const fetchpartyName = createAsyncThunk(
    "receipt/fetchpartyName",
    async ({ firmId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getPartyByFirm&firmId=${firmId}`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// 👉 GET RECEIPT NO
export const fetchReceiptNo = createAsyncThunk(
    "receipt/fetchReceiptNo",
    async ({ receiptType }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getReceiptNo&receiptType=${receiptType}`
            );
            return response.data?.data?.receiptNo || "";
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchSettlementNo = createAsyncThunk(
    "receipt/fetchSettlementNo",
    async ({ receiptType }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getSettlementNo&receiptType=${receiptType}`
            );
            return response.data?.data?.receiptNo || "";
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// 👉 INSERT SALE RECEIPT
export const insertSaleReceipt = createAsyncThunk(
    "receipt/insertSaleReceipt",
    async (postData, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${baseUrl}?apicall=insertSaleReceiptEntry`,
                postData
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// 👉 GET RECEIPT REGISTER DATA
export const fetchReceiptDetails = createAsyncThunk(
    "receipt/fetchReceiptDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getReceiptDetails`
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
// 👉 GET Settlement REGISTER DATA
export const fetchSettlementRegDetails = createAsyncThunk(
    "receipt/fetchSettlementRegDetails",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getSettlementRegDetails`
            );
            console.log("settlement Reg API=>", response.data);
            return response.data;

        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
// 👉 GET RECEIPT DATA BY ID (PRINT PAGE)
export const fetchRcptData = createAsyncThunk(
    "receipt/fetchRcptData",
    async ({ id, type }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getReceiptInfoById&Id=${id}&type=${type}`
            );
            console.log("Receipt Print API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
// 👉 GET RECEIPT DATA BY ID (PRINT PAGE)
export const fetchSettlementData = createAsyncThunk(
    "receipt/fetchSettlementData",
    async ({ id, type }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getSettlementInfoById&Id=${id}&type=${type}`
            );
            //  console.log("Receipt Print API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
// 👉 GET RECEIPT DATA BY ID (PRINT PAGE)
export const fetchInvoiceData = createAsyncThunk(
    "receipt/fetchInvoiceData",
    async ({ id, type }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getSettlementInfoById&Id=${id}&type=${type}`
            );
            //  console.log("Receipt Print API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchInvoiceDataPrint = createAsyncThunk(
    "receipt/fetchInvoiceDataPrint",
    async ({ id, type }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getSettlementInvInfo&Id=${id}&type=${type}`
            );
            //  console.log("Receipt Print API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchAdavanceDataPrint = createAsyncThunk(
    "receipt/fetchAdavanceDataPrint",
    async ({ id, type }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getSettlementAdvInfo&Id=${id}&type=${type}`
            );
            //  console.log("Receipt Print API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const fetchTotAdvAmt = createAsyncThunk(
    "receipt/fetchTotAdvAmt",
    async ({ firmId, partyId, receiptType }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=gettotAdvAmt&firmId=${firmId}&partyId=${partyId}&receiptType=${receiptType}`
            );
            console.log("Receipt Print API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchSettlementDetails = createAsyncThunk(
    "receipt/fetchSettlementDetails",
    async ({ firmId, partyId, receiptType }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getSettlementInfo&firmId=${firmId}&partyId=${partyId}&receiptType=${receiptType}`
            );
            console.log("Settlement Details API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchInvoiceDetails = createAsyncThunk(
    "receipt/fetchInvoiceDetails",
    async ({ firmId, partyId, receiptType }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=getInvoiceInfo&firmId=${firmId}&partyId=${partyId}&receiptType=${receiptType}`
            );
            // console.log("Inv Details API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const deleteReceiptDetails = createAsyncThunk(
    "receipt/deleteReceiptDetails",
    async ({ id, rcptType }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=deleteReceiptDetails&id=${id}&rcptType=${rcptType}`
            );
            // console.log("Inv Details API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const deleteSettlementDetails = createAsyncThunk(
    "receipt/deleteSettlementDetails",
    async ({ id, sType }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${baseUrl}?apicall=deleteSettlementDetails&id=${id}&sType=${sType}`
            );
            // console.log("Inv Details API =>", response.data);
            return response.data; // ✅ return full response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
// 👉 INSERT SETTLEMENT ENTRY
export const insertSettlementEntry = createAsyncThunk(
    "receipt/insertSettlementEntry",
    async (postData, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${baseUrl}?apicall=insertSettlementEntry`,
                postData
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

/* ===================== SLICE ===================== */

const receiptApiSlice = createSlice({
    name: "ReceiptDatalist",
    initialState: {
        isLoading: false,
        isError: false,

        // helpers
        partyByFirm: [],
        receiptNo: "",
        settlementNo: "",
        totAdvAmt: "",

        // register
        receiptDetails: [],
        settlementDetails: [],
        invoiceDetails: [],
        settlementRegDetails: [],
        settlementInvRegInfo: [],
        settlementAdvRegInfo: [],
        // print page
        receiptData: null,
        receiptInfo: [],
        settlementInfo: [],
    },
    reducers: {},
    extraReducers: (builder) => {

        builder
            /* ===== PARTY ===== */
            .addCase(fetchpartyName.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchpartyName.fulfilled, (state, action) => {
                state.isLoading = false;
                state.partyByFirm = action.payload?.data || [];
            })
            .addCase(fetchpartyName.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })

            /* ===== RECEIPT NO ===== */
            .addCase(fetchReceiptNo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchReceiptNo.fulfilled, (state, action) => {
                state.isLoading = false;
                state.receiptNo = action.payload;
            })
            .addCase(fetchReceiptNo.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })
            /* ===== Settlement NO ===== */
            .addCase(fetchSettlementNo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchSettlementNo.fulfilled, (state, action) => {
                state.isLoading = false;
                state.settlementNo = action.payload;
            })
            .addCase(fetchSettlementNo.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })
            /*============totadvamt======*/

            .addCase(fetchTotAdvAmt.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchTotAdvAmt.fulfilled, (state, action) => {
                const row = action.payload?.data?.[0];
                state.totAdvAmt = row?.totAmt ? Number(row.totAmt) : 0;
            })
            .addCase(fetchTotAdvAmt.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            /* ===== INSERT ===== */
            .addCase(insertSaleReceipt.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(insertSaleReceipt.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(insertSaleReceipt.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })

            /* ===== REGISTER ===== */
            .addCase(fetchReceiptDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchReceiptDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.receiptDetails = action.payload?.data || [];
            })
            .addCase(fetchReceiptDetails.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })

            /* =====settlement REGISTER ===== */
            .addCase(fetchSettlementRegDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchSettlementRegDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.settlementRegDetails = action.payload?.data || [];
            })
            .addCase(fetchSettlementRegDetails.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })

            /* =====  SettlementDetails ===== */
            .addCase(fetchSettlementDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchSettlementDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.settlementDetails = action.payload?.data || [];
            })
            .addCase(fetchSettlementDetails.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })
            /* =====  InvoiceDetails ===== */
            .addCase(fetchInvoiceDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchInvoiceDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.invoiceDetails = action.payload?.data || [];
            })
            .addCase(fetchInvoiceDetails.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })

            /* ==== settlement invoice details === */
            .addCase(fetchInvoiceDataPrint.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchInvoiceDataPrint.fulfilled, (state, action) => {
                state.isLoading = false;
                state.settlementInvRegInfo = action.payload?.data || [];
            })
            .addCase(fetchInvoiceDataPrint.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })
            /* ===== settlement advance details ==== */

            .addCase(fetchAdavanceDataPrint.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAdavanceDataPrint.fulfilled, (state, action) => {
                state.isLoading = false;
                state.settlementAdvRegInfo = action.payload?.data || [];
            })
            .addCase(fetchAdavanceDataPrint.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
            })

            /* ===== PRINT DATA ===== */
            .addCase(fetchRcptData.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(fetchRcptData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.receiptData = action.payload?.data?.[0] || null;
                state.receiptInfo = action.payload?.Info || [];
            })
            .addCase(fetchRcptData.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
                state.receiptData = null;
                state.receiptInfo = [];
            })
            /* ===== PRINT Settlement DATA ===== */
            .addCase(fetchSettlementData.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(fetchSettlementData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.receiptData = action.payload?.data?.[0] || null;
                state.settlementInfo = action.payload?.Info || [];
            })
            .addCase(fetchSettlementData.rejected, (state) => {
                state.isLoading = false;
                state.isError = true;
                state.receiptData = null;
                state.settlementInfo = [];
            })


    },
});


/* ===================== SELECTORS ===================== */

export const selectPartyByFirm = (state) =>
    state.ReceiptDatalist.partyByFirm;

export const selectReceiptNo = (state) =>
    state.ReceiptDatalist.receiptNo;

export const selectReceiptDetails = (state) =>
    state.ReceiptDatalist.receiptDetails;

export const selectSettlementRegDetails = (state) =>
    state.ReceiptDatalist.settlementRegDetails;

export const selectSettlementInvRegDetails = (state) =>
    state.ReceiptDatalist.settlementInvRegInfo;

export const selectSettlementAdvRegDetails = (state) =>
    state.ReceiptDatalist.settlementAdvRegInfo;

export const selectSettlementDetails = (state) =>
    state.ReceiptDatalist.settlementDetails;

export const selectInvoiceDetails = (state) =>
    state.ReceiptDatalist.invoiceDetails;

export const selectReceiptData = (state) =>
    state.ReceiptDatalist.receiptData;

export const selectReceiptInfo = (state) =>
    state.ReceiptDatalist.receiptInfo;

export const selectReceiptLoading = (state) =>
    state.ReceiptDatalist.isLoading;

export const selectReceiptError = (state) =>
    state.ReceiptDatalist.isError;

export default receiptApiSlice.reducer;
